<template>
    <ds-main-layout>
        <slot />
    </ds-main-layout>
</template>
